<template>
  <section class="cracha-userProfile">
    <Header v-show="profileConfig.showHeader"/>
    <div class="cracha-userProfile-wrapper" @click="showImageCropper=false">
      <!-- <div class="userProfile-first-container" v-if="profileConfig.position=='right'"> -->

        <div class="cracha-user-panel">
          <div class="user-image-and-fields">
            <div class="user-fields-wrapper">
              <label class="cracha-userProfile-inputs-label" for="name">{{profileConfig.field.name.placeholder}}</label>
              <input class="cracha-userProfile-field-input" ref="userName" v-if="profileConfig.field.name.enable" id="name" type="field"  v-model="user.name" @keydown.esc="user.name=''" @keypress.enter="saveUserProfile">
              <!-- <label class="cracha-userProfile-inputs-label" for="company">{{profileConfig.field.company.placeholder}}</label> -->
              <!-- <input class="cracha-userProfile-field-input" v-if="profileConfig.field.company.enable" id="company" type="field"  v-model="user.company" @keydown.esc="user.company=''" @keypress.enter="saveUserProfile"> -->
              <label class="cracha-userProfile-inputs-label" for="role">{{profileConfig.field.role.placeholder}}</label>
              <input class="cracha-userProfile-field-input" v-if="profileConfig.field.role.enable" id="role" type="field"  v-model="user.role" @keydown.esc="user.role=''" @keypress.enter="saveUserProfile">
              <label class="cracha-userProfile-inputs-label" for="email">{{profileConfig.field.email.placeholder}}</label>
              <input class="cracha-userProfile-field-input" v-if="profileConfig.field.email.enable" id="email" type="field"  v-model="user.email" @keydown.esc="user.email=''" @keypress.enter="saveUserProfile">
              
            </div>           
          </div>
          <div class="profile-buttons" v-if="true">
            <button class="cracha-user-profile-btn" :style="{backgroundColor:'transparent'}" v-if="profileConfig.cancelText != ''" @click="resetInputs"><p v-html="profileConfig.cancelText"></p></button>
            <button class="cracha-user-profile-btn" :style="{backgroundColor: profileConfig.buttonSaveColor, borderColor: profileConfig.buttonSaveColor}" @click="saveUserProfile" v-if="showSendButton"><p v-html="profileConfig.saveText"></p></button>
          </div>
        </div>
      <!-- </div> -->
      <!-- <div class="userProfile-second-container"> -->
        <div class="feed-container-embed-full" v-if="showFeed">
          <Feed :userIsAdmin="false" />
        </div>
      <!-- </div> -->
    </div>
    <ImageCropper ref="imageCropper" :key='imageCropperKey' v-if="showImageCropper" :src="imgSrc" @cancelCrop="restoreOldPic" @okCrop="showImageCropper=false; uploadImage" @croppedUrl="croppedUrlHandler" />
     <!-- <div class="footer-wrapper"> -->
    <Footer />
    <!-- </div> -->
  </section>
</template>
<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import api from '@/services/api';
import DefaultAvatar from '@/assets/img/personIcon.png';
import ImageCropper from '@/components/general/ImageCropper.vue';
import Feed from '../components/user_content/Feed.vue';

export default {
  name: 'Cracha',

  components: {
    Header,
    Footer,
    ImageCropper,
    Feed,
  },
  data() {
    return {
      showFeed: false,
      imageCropperKey: 0,
      imgSrc: 'https://images.squarespace-cdn.com/content/v1/583a6a85893fc0a390c3a288/1555547935956-H8SVCMU7JH9HRKOK5P2C/ke17ZwdGBToddI8pDm48kAD-r7j4YN7tv4midO0oeTl7gQa3H78H3Y0txjaiv_0fDoOvxcdMmMKkDsyUqMSsMWxHk725yiiHCCLfrh8O1z4YTzHvnKhyp6Da-NYroOW3ZGjoBKy3azqku80C789l0prfa1Z6IeUrCPboCAmmHZmqcVosbeIW7EPiNy517darchQ3_FWKtlkzmpwe5AHLOA/home-page-hero%402x.jpg?format=2500w',
      showSendButton: true,
      selectedFile: null,
      showProgressBar: false,
      showImageCropper: false,
      barWidth: '0%',
      user: {},
      agree: true,
      buyer: false,
      shakeAgree: false,
      oldUser: {},
      accessConfig: {
        firstPage: '',
        firstPageParams: {},
      },
      profileConfig: {},
      createUser: false,
    };
  },
  methods: {
    restoreOldPic() {
      this.user.picture = this.oldUser.picture;
      this.showImageCropper = false;
    },
    dataURItoBlob(dataURI) {
      let byteString = atob(dataURI.split(',')[1]);
      let mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0];
      let ab = new ArrayBuffer(byteString.length);
      let ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      let blob = new Blob([ab], { type: mimeString });
      blob.name = 'cropped.jpg';

      return blob;
    },
    prepareImageFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;

      let downloadLink = document.createElement('a');
      downloadLink.setAttribute('download', 'user-image.jpg');
      let url = URL.createObjectURL(theBlob);
      downloadLink.setAttribute('href', url);
      downloadLink.click();
      this.selectedFile = theBlob;
      return theBlob;
    },
    croppedUrlHandler(croppedUrl) {
      this.user.picture = croppedUrl;
      // console.log('croppedurl: ' + JSON.stringify(croppedUrl));
      this.selectedFile = this.dataURItoBlob(croppedUrl);
      this.uploadImage();
      // console.log('selected file: ' + this.selectedFile);
    },
    checkEnterPress(key) {
      //console.log('KEY PRESS');
      if (key.keyCode == 13) this.saveUserProfile();
      if (key.keyCode == 27) this.resetInputs();
    },
    resetInputs() {
      //this.user = this.oldUser;
      //this.showSendButton = true;
      this.$refs.userName.focus();
      // this.$router.back();
    },
    // API POST SAVE PROFILE
    saveUserProfile() {
      // console.log('other: ' + JSON.stringify(this.profileConfig.field.other));
      api
        .put(`event/${this.$store.state.eventId}/user/${this.$store.state.user.id}`, {
          name: this.user.name,
          image: this.user.picture,
          //email: this.user.email,
          company: this.user.company,
          role: this.user.role,
          about_me: this.user.about_me,
          cpf: this.user.cpf,
          generate_password: this.user.generate_password,
          nickname: this.user.nickname,
          gender: this.user.gender,
          date_of_birth: this.user.date_of_birth,
          telephone: this.user.telephone,
          cep: this.user.cep,
          street: this.user.street,
          number: this.user.number,
          complement: this.user.complement,
          neighborhood: this.user.neighborhood,
          city_id: this.user.city_id,
          state_code: this.user.state_code,
          country_code: this.user.country_code,
          language_code: this.user.language_code,
          timezone: this.user.timezone,
        })
        .then(response => {
          // console.log('Profile updated', response.config.data);
          if (response) {
            // console.log('save profile user responsedata: ' + response.config);
            let data = response.config.data;
            let name = JSON.parse(data).name;
            // console.log('save profile user data: ' + name);
            this.$store.commit('setUserName', name ? name : this.$store.state.user.name);
            this.$router.back();
          }
        })
        .catch(err => console.error(err));
    },
    imgFilePicked(event) {
      this.selectedFile = event.target.files[0];
      this.showSendButton = false;
      this.user.picture = URL.createObjectURL(event.target.files[0]);
      this.imgSrc = URL.createObjectURL(event.target.files[0]);
      this.imageCropperKey++;
      this.showImageCropper = true;
      this.showSendButton = true;
      // console.log('FILE CHANGED: ' + this.selectedFile);
    },
    onCancel() {
      // console.log(this.oldUser.picture);
      // this.user.picture = this.oldUser.picture;
      this.showSendButton = true;
    },

    // API POST SAVE PHOTO
    uploadImage() {
      this.showProgressBar = true;
      //console.log('ON UPLOAD');
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      api
        .post(`event/${this.$store.state.eventId}/materialUpload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: progressEvent => {
            // console.log('progress: ' + Math.round((progressEvent.loaded / progressEvent.total) * 100) + '%');
            this.barWidth = Math.round((progressEvent.loaded / progressEvent.total) * 100) + '%';
            if (progressEvent.loaded === progressEvent.total) {
              this.showSendButton = true;
              this.showProgressBar = false;
            }
          },
        })
        .then(response => {
          //console.log('file upload', response);
          if (response.data) {
            this.user.picture = response.data.url;
          }
        })
        .catch(err => console.error(err));
    },

    loadValues() {
      if (this.$store.state.user.id) {
        try {
          api
            .get(`event/${this.$store.state.eventId}/user/${this.$store.state.user.id}`)
            .then(response => {
              //console.log('User= ',response.data);
              if (response.data) {
                //console.log('Response Data =', response.data);
                this.user = {
                  key: response.data.user_id,
                  picture: response.data.image ? response.data.image : DefaultAvatar,
                  name: response.data.name,
                  company: response.data.company,
                  role: response.data.role,
                  email: response.data.email,
                  about_me: response.data.about_me,
                  firstLogin: response.data.first_login,
                  lastLogin: response.data.last_login,
                  other: response.data.other,
                };
                if (this.user.other) {
                  this.user.other = JSON.parse(this.user.other);
                  this.user.buyer = this.user.other.buyer ? this.user.other.buyer : false;
                  this.buyer = this.user.buyer;
                } else {
                  this.user.buyer = false;
                }
                this.oldUser = { ...this.user };
                // this.name = this.user.name;
                // this.picture = this.user.picture == DefaultAvatar ? null : this.user.picture;
                // this.company = this.user.company;
                // this.role = this.user.role;
              }
            })
            .catch(err => console.error(err));
        } catch (error) {
          console.log(error);
        }
        this.createUser = false;
      } else {
        if (accessConfig.publicSignIn) {
          //Must create user
          this.createUser = true;
        } else {
          //Error
          this.createUser = false;
        }
      }
    },
  },
  beforeMount() {
    this.accessConfig = this.$store.state.template.accessConfig;
    this.profileConfig = this.$store.state.template.profileConfig;
    this.loadValues();
  },
};
</script>

<style lang="scss" scoped>
.cracha-userProfile {
  position: relative;
  background-color: white;
  background-position: center;
  background-size: cover;
  background-repeat: repeat-y;
  width: 100vw;
  @include media('<=900px') {
    background-position: left;
    background-size: contain;
  }
}
.cracha-userProfile-wrapper {
  // background-color: var(--main-color);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 96.8vh;
  padding-top: 100px;
  background: url('https://proto-assets.s3.amazonaws.com/Ache/static/img/cracha%2B.jpg');
  background-position: top 0px right 50%;
  background-repeat: no-repeat;
  background-size: contain;
  @include media('<=330px') {
    background-size: contain;
  }
}
.userProfile-background-img {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  // height: 100%;
  z-index: 0;
}

.userProfile-first-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 55%;
  z-index: 1;
  height: 100%;
  // padding-top: 80px;
}
.userProfile-eventLogo-internal {
  img {
    width: auto;
    max-height: 30vh;
  }
}
.userProfile-second-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-width: 40%;
  height: 100%;
  z-index: 1;
  padding: 5%;
  // margin-top: 100px;
}
.userProfile-title {
  // align-self: center;
  margin: 2% 0 2% 0;
  // width: 118px;
  // border-bottom: 1px solid white;
  h1 {
    font-size: 32px;
    letter-spacing: 2px;
    text-align: center;
    margin-bottom: 0;
  }
}
.feed-container-embed-full {
  width: 80%;
}
.cracha-user-panel {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  opacity: '100%';
  width: 50vh;
  flex-grow: 1;
  padding: 1% 2% 0% 2%;
  @include media('<=520px') {
    flex-grow: 0;
    margin-top: 72vw;
    width: 80vw;
  }
}
// .user-image-and-fields {
//   // background-color: darkgrey;
//   display: flex;
//   // height: 26vh;
//   // margin: 2.5% 3%;
//   border-radius: var(--input-borderRadius);
//   // padding-right: 2%;

//   // .user-image-wrapper {
//   //   // background-color: yellowgreen;
//   //   display: flex;
//   //   flex-direction: column;
//   //   align-items: center;
//   //   justify-content: flex-start;
//   //   padding: 2.5% 2.5% 2.5% 0;
//   //   // margin-right: 20px;
//   //   gap: 10px;
//   //   width: 35%;
//   //   height: 100%;

//   //   img {
//   //     position: relative;
//   //     object-fit: cover;
//   //     object-position: center;
//   //     background-color: transparent;
//   //     width: 70%;
//   //     width: 150px;
//   //     height: 150px;
//   //     border: 4px solid white;
//   //     border-radius: 50%;
//   //   }
//   //   .user-image-uploader {
//   //     cursor: pointer;
//   //     display: flex;
//   //     justify-content: center;
//   //     font-size: 0.8rem;
//   //     width: 100%;
//   //     max-height: 20%;
//   //     padding: 2% 0 2% 2%;
//   //     z-index: 1;
//   //     .image-uploader-chose-btn {
//   //       text-decoration: underline;
//   //       color: var(--input-text);
//   //       opacity: 0.6;
//   //     }
//   //     .image-uploader-cancel-btn {
//   //       cursor: pointer;
//   //       border: none;
//   //       height: 36px;
//   //       padding: 8px;
//   //       color: var(--button-background);
//   //       border: 2px solid var(--button-background);
//   //       margin-right: 5px;
//   //     }
//   //     .image-uploader-ok-btn {
//   //       cursor: pointer;
//   //       border: none;
//   //       height: 36px;
//   //       padding: 10px;
//   //       color: var(--button-text);
//   //       background-color: var(--button-background);
//   //       margin-left: 5px;
//   //     }
//   //     .progressbar-container {
//   //       background-color: var(--main-color);
//   //       height: 8px;
//   //       width: 60%;
//   //     }
//   //     .progressbar {
//   //       background-color: teal;
//   //       height: 8px;
//   //       width: 20%;
//   //     }
//   //   }
//   // }

//   .user-fields-wrapper {
//     display: flex;
//     flex-direction: column;
//     width: 100%;
//     padding: 0 5%;
//     // margin-bottom: 20px;

//     .cracha-userProfile-field-input {
//       font-size: 1.2rem;
//       color: white;
//       padding: 1% 1% 1% 0;
//       width: 100%;
//       border: 0;
//       outline: none;
//       background-color: transparent;
//       border-bottom: 1px solid #ffffff70;

//       // border-radius: 15px;
//     }

//     .cracha-userProfile-field-input:focus {
//       // display: none;
//       // background-color: darkgray;
//       // color: var(--input-text);
//       background-color: transparent;
//     }
//     .cracha-userProfile-field-input::placeholder {
//       /* Chrome, Firefox, Opera, Safari 10.1+ */
//       // color: var(--input-text);
//       color: white;
//       opacity: 1; /* Firefox */
//       font-size: 1rem;
//       font-weight: 400;
//     }
//   }
// }
.cracha-userProfile-inputs-label {
  margin: 20px 0 4px 0;
  color: white;
  letter-spacing: 3px;
  opacity: 0.7;
}
.userProfile-other {
  width: 100%;
  padding: 1% 0;
}
.userProfile-other-text {
  color: var(--input-text);
  a {
    color: var(--input-text);
    opacity: 0.7;
    text-decoration: underline;
  }
}
.user-description {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 15vh;
  // background-color: gray;
  // width: 100%;
  padding: 0%;
  .description-textarea {
    position: relative;
    font-size: 1.4rem;
    color: var(--input-text);
    padding: 1% 0;
    width: 100%;
    height: 100%;
    border: 0;
    border-bottom: 1px solid var(--input-text);
    outline: none;
    background-color: transparent;
    overflow: visible;
    resize: none;
  }
}
.profile-buttons {
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  // gap: 15px;
  height: 80px;
  // padding-right: 4%;
  // background-color: lightblue;
  .cracha-user-profile-btn {
    cursor: pointer;
    border: none;
    outline: none;
    padding: 15px;
    color: var(--button-text);
    background-color: var(--button-background);
    border: 2px solid var(--button-background);
    margin-top: 10px;
    border-radius: 30px;
    width: 100%;
    &:last-child {
      margin-left: 15px;
    }
  }
}
</style>